import { Icon24IterateVideoLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const VideoIteratorIconLocal: SvgComponent = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.title ? <title>{props.title}</title> : null}
      <g clipPath="url(#clip0_1022_696)">
        <path
          d="M18.75 7.05005L21 4.80005L18.75 2.55005"
          stroke="white"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 10.8C3 9.20875 3.63214 7.68263 4.75736 6.55741C5.88258 5.43219 7.4087 4.80005 9 4.80005H21"
          stroke="white"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 16.95L3 19.2L5.25 21.45"
          stroke="white"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 13.2C21 14.7913 20.3679 16.3174 19.2426 17.4426C18.1174 18.5678 16.5913 19.2 15 19.2H3"
          stroke="white"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.2498 12L10.4998 9.5V14.5L14.2498 12Z"
          stroke="white"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1022_696">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const VideoIteratorIcon = fplIcon(VideoIteratorIconLocal, Icon24IterateVideoLarge);
